<template>
    <div>
        <CRow><CCol sm="12" xl="12">
                <CButton @click="collapse=!collapse" color="primary" class="mb-2 mr-2">
                    Filter
                </CButton>
                <CCollapse :show="collapse" :duration="400">
                    <CCard>
                        <CCardHeader>
                            <strong>Filter Options</strong>
                        </CCardHeader>
                        <CCardBody>
                            <CRow>
                                <CCol sm="3">
                                    <CInput v-model="form.id.val" :description="form.id.inv" label="ID" />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.name.val" :description="form.name.inv" label="Name" />
                                </CCol>
                                <CCol sm="3">
                                    <label>Processes</label>
                                    <model-select :options="input_proccesses" v-model="form.input_proccess_id.val" placeholder="Please Select">
                                    <small class="form-text text-muted w-100">{{form.input_proccess_id.inv}}</small>
                                    </model-select>
                                </CCol>
                                <CCol sm="3">
                                    <label>User</label>
                                    <model-select :options="users" v-model="form.user_id.val" placeholder="Please Select">
                                    <small class="form-text text-muted w-100">{{form.user_id.inv}}</small>
                                    </model-select>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="3">
                                    <CInput v-model="form.compare_with.val" :description="form.compare_with.inv" label="Compare with" />
                                </CCol>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.compare_type.val"
                                        :description="form.compare_type.inv"
                                        label="Compare Type"
                                        :options="[
                                            {value: '==', label:'=='},
                                            {value: '!=', label:'!='},
                                            {value: '>=', label:'>='},
                                            {value: '<=', label:'<='},
                                            {value: '<', label:'<'},
                                            {value: '>', label:'>'},
                                        ]"
                                        placeholder="Please Select"
                                        @change="form.compare_type.val=$event.target.value"
                                    />
                                </CCol>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.is_active.val"
                                        :description="form.is_active.inv"
                                        label="State"
                                        :options="[
                                            {value: 'true', label:'Active'},
                                            {value: 'false', label:'Inactive'},
                                        ]"
                                        placeholder="Please Select"
                                        @change="form.is_active.val=$event.target.value"
                                    />
                                </CCol>
                                <CCol sm="3">
                                    <label>Last Fire Time Stamp</label>
                                    <date-picker placeholder="Please Select" locale="en" v-model="form.last_fire_timestamp.val"></date-picker>
                                    <small class="form-text text-muted w-100">{{form.last_fire_timestamp.inv}}</small>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="3">
                                    <CInput v-model="form.last_fire_values.val" :description="form.last_fire_values.inv" label="Last Fire Values" />
                                </CCol>
                            </CRow>
                            <br>
                            <div class="form-group form-actions">
                                <CButton @click="validator();filter=true;page=1;count();get();" color="primary" class="mr-2">Filter</CButton>
                                <CButton @click="remove_filter" color="danger">Remove Filter</CButton>
                            </div>
                        </CCardBody>
                    </CCard>
                </CCollapse>
            </CCol>
            <CCol sm="12" xl="12">
                <CCard>
                    <CCardHeader>
                        <strong>Triggers</strong>
                        <div class="card-header-actions">
                            Number of All Rows: {{row_count}}
                        </div>
                        </CCardHeader>
                    <CCardBody>
                        <CDataTable hover striped :items="items" :fields="fields" :noItemsView="{ noItems: 'No items to show.' }">
                            <template #is_active="data">
                                <td>
                                    <CBadge :color="get_badge(data.item.is_active)">
                                        {{data.item.is_active}}
                                    </CBadge>
                                </td>
                            </template>
                            <template #input_proccess_name="data">
                                <td>
                                    <router-link :to="`/data/proccesses/${data.item.input_proccess_id}/details`">{{data.item.input_proccess_name}}</router-link>
                                </td>
                            </template>
                            <template #user_name="data">
                                <td>
                                    <router-link :to="`/user/${data.item.user_id}/details`">{{data.item.user_name}}</router-link>
                                </td>
                            </template>
                            <template #action="data">
                                <td>
                                    <template>
                                    <div class="flex-container">
                                        <div @click="redirect_to(`/trigger/${data.item.id}/details`)"
                                            v-c-tooltip.hover="'Details'">
                                        <CIcon height="20" :content="$options.details"/>
                                        </div>
                                        <div v-show="$store.state.perm['arbitrage.InputProccessTriggers'].put"
                                            @click="redirect_to(`/trigger/${data.item.id}/update`)"
                                            v-c-tooltip.hover="'َUpdate'">
                                        <CIcon height="20" :content="$options.update"/>
                                        </div>
                                        <div v-show="$store.state.perm['arbitrage.InputProccessTriggers'].delete"
                                            @click="delete_modal=true;id=data.item.id"
                                            v-c-tooltip.hover="'Delete'">
                                        <CIcon height="20" :content="$options.delete"/>
                                        </div>
                                    </div>
                                    </template>
                                </td>
                            </template>
                        </CDataTable>
                            <br>
                            <div> 
                                <CPagination
                                :activePage.sync="page"
                                :pages="page_count"
                                align="center"
                                :doubleArrows="true"
                                />
                            </div>
                        </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <CModal
            title="Alert"
            size="sm"
            color="danger"
            :show.sync="delete_modal"
            >
            <p>Are you sure?</p>
            <template #footer>
                <CButton @click="delete_modal=false" color="secondary">No</CButton>
                <CButton @click="delete_row" color="danger">Yes</CButton>
            </template>
        </CModal>
    </div>
</template>
<script>
import { ModelSelect } from 'vue-search-select'
import { cilListRich, cilPencil, cilTrash } from '@coreui/icons'
export default {
    components: { ModelSelect },
    details: cilListRich, update: cilPencil, delete: cilTrash,
    data () {
        return {
            row_count: '',
            items: [],
            fields: [
                { key: 'id', label: 'ID' },
                { key: 'name', label: 'Name' },
                { key: 'input_proccess_name', label: 'Input Process' },
                { key: 'user_name', label: 'User' },
                { key: 'compare_with', label: 'Compare with' },
                { key: 'compare_type', label: 'Compare Type' },
                { key: 'is_active', label: 'State' },
                { key: 'action', label: 'Action' },
            ],
            collapse: false,
            filter: false,
            form: {
                id: {val: '', inv: '', v: { max: 1024 }},
                name: {val: '', inv: '', v: { max: 1024 }},
                input_proccess_id: {val: '', inv: '', v: { max: 1024 }},
                user_id: {val: '', inv: '', v: { max: 1024 }},
                compare_with: {val: '', inv: '', v: { max: 1024 }},
                compare_type: {val: '', inv: '', v: { max: 1024 }},
                is_active: {val: '', inv: '', v: { max: 1024 }},
                last_fire_timestamp: {val: '', inv: '', v: { max: 1024 }},
                last_fire_values: {val: '', inv: '', v: { max: 1024 }},
            },
            input_proccesses: [],
            users: [],
            disable: false,
            page: 1,
            page_count: 0,
            offset: 0,
            delete_modal: false,
            id: 0,
        }
    },
    watch: {
        page: {
            handler(){
                this.count();
                this.get();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        },
    },
    mounted(){
        this.count();
        this.get();
        this.get_input_proccesses();
        this.get_users();
    },
    methods: {
        validator() {
            for (const key in this.form) {
                this.form[key].inv = '';
            }
            this.disable = false;
            for (const key in this.form) {
                for (const k in this.form[key].v) {
                    switch (k) {
                        case 'req':
                            if (this.form[key].val == '') {
                                this.form[key].inv = 'This field is required.';
                                this.disable = true;
                            }
                            break;
                        case 'max':
                            if (this.form[key].val != '') {
                                if (this.form[key].val.length > this.form[key].v[k]) {
                                    this.form[key].inv = `Must be a maximum of ${this.form[key].v[k]} characters.`;
                                    this.disable = true;
                                }
                            }
                            break;
                    }
                }
            }
        },
        get_input_proccesses(){
            this.axios.get('arbitrage/input_proccesses/')
                .then(res => {
                    res.data.map(val => {
                        this.input_proccesses.push({value: val.id, text: val.name});
                    });
                })  
        },
        get_users(){
            this.axios.get('system/users/')
                .then(res => {
                    res.data.map(val => {
                        this.users.push({ value: val.id, text: `${val.id} - ${val.first_name} ${val.last_name}` });
                    });
                })
        },
        count() {
            if(this.disable == false) {
                let filter = '';
                if(this.filter){
                    for (const key in this.form) {
                        if(this.form[key].val != ''){
                            filter += `&${key}=` + this.form[key].val;
                        }
                    }
                }
                this.axios.get('arbitrage/input_proccess_triggers/?count=1' + filter)
                    .then(res => {
                        this.row_count = String(res.data.count).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        if(res.data.count > 100){
                            this.page_count = Math.ceil(res.data.count / 100);
                        } else {
                            this.page_count = 1;
                        }
                    })
            }
        },
        get() {
            if (this.disable == false) {
                this.offset = 0;
                if(this.page != 1){
                    this.offset = (this.page * 100) - 99;
                }
                let filter = '';
                if(this.filter){
                    for (const key in this.form) {
                        if(this.form[key].val != ''){
                            filter += `&${key}=` + this.form[key].val;
                        }
                    }
                }
                this.axios.get('arbitrage/input_proccess_triggers/' 
                    + '?limit=100' 
                    + '&offset=' + this.offset
                    + '&user_info=1'
                    + '&input_proccess_info=1'
                    + filter)
                    .then(res => {
                        res.data.map(val => {
                            val.input_proccess_name = val.input_proccess_info.name;
                            val.user_name = `${val.user_info.first_name} ${val.user_info.last_name}`;
                            switch(val.is_active){
                                case true:
                                    val.is_active = 'Active';
                                    break;
                                case false:
                                    val.is_active = 'Inactive';
                                    break;
                            }
                        });
                        this.items = res.data;
                    })
            }
        },
        delete_row() {
			this.axios.delete('arbitrage/input_proccess_triggers/'
			+ '?id=' + this.id)
			.then(() => {
				this.$notify({
					group: 'foo',
					type: 'success',
					text: 'Deleted Successfully.'
                });
				this.delete_modal = false;
                this.count();
				this.get();
			})
			.catch(() => {
				this.$notify({
					group: 'foo',
					type: 'error',
					text: 'Error! please try again.'
                });
                this.delete_modal = false;
			})
        },
        redirect_to(route) {
            this.$router.push(route);
        },
        get_badge(status) {
            switch (status) {
                case 'Active': return 'success'
                case 'Inactive': return 'danger'
                default: 'secondary'
            }
        },
        remove_filter() {
            for (const key in this.form) {
                this.form[key].val = '';
                this.form[key].inv = '';
            }
            this.disable = false;
            this.filter = false;
            this.page = 1;
            this.count();
            this.get();
        },
    },
}
</script>
